import styled, {
  css
} from "styled-components";
import {
  Link
} from "react-router-dom";
import {
  logo_inline_w
} from "../../constants/GlobalConst";
const SIDEBAR_BG = "#20242b";
const SIDEBAR_BG_DARK = "#191c22";
const SIDEBAR_BORDER =
    "rgba(255, 255, 255, 0.08)";
const TEXT_DEFAULT =
    "rgba(255, 255, 255, 0.68)";
const TEXT_STRONG = "#ffffff";
const ACCENT = "#f5811f";

export const menuPL = "18px";

export const AsideRoot = styled.aside`
  position: relative;
  z-index: 220;
  width:
    ${({$collapsed}) =>
    $collapsed
        ? "76px"
        : "228px"};
  min-width:
    ${({$collapsed}) =>
    $collapsed
        ? "76px"
        : "228px"};
  min-height: 100vh;
  flex: 0 0
    ${({$collapsed}) =>
    $collapsed
        ? "76px"
        : "228px"};
  transition:
    width 0.22s ease,
    min-width 0.22s ease,
    flex-basis 0.22s ease;

  @media (max-width: 960px) {
    position: fixed;
    inset: 0 auto 0 0;
    width: 228px;
    min-width: 228px;
    min-height: 100vh;
    flex-basis: 228px;
    transform: translateX(${({$mobileOpen}) => $mobileOpen ? "0" : "-102%"});
    transition: transform .22s ease;
  }
`;

export const AsideContainer =
    styled.div`
    position: sticky;
    top: 0;
    display: flex;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    flex-direction: column;
    overflow: hidden;
    border-right:
      1px solid ${SIDEBAR_BORDER};
    background: linear-gradient(180deg, ${SIDEBAR_BG} 0%, ${SIDEBAR_BG_DARK} 100%);
    transition: width 0.22s ease;

    @media (max-width: 960px) {
      width: 228px;
      box-shadow: 18px 0 40px rgba(15, 23, 42, .28);
    }
  `;

export const AsideHeader =
    styled.div`
    display: flex;
    min-height: 82px;
    align-items: center;
    justify-content:
      ${({$collapsed}) =>
        $collapsed
            ? "center"
            : "center"};
    padding:
      ${({$collapsed}) =>
        $collapsed
            ? "0"
            : "0 18px"};
    // border-bottom:
    //   1px solid ${SIDEBAR_BORDER};

    & > a {
      display: flex;
      min-width: 0;
      align-items: center;
      justify-content: center;
      color: #fff;
      text-decoration: none;
    }
  `;

export const Logo = styled.div`
  width: 176px;
  height: 44px;
  background-image:
    url(${logo_inline_w});
  background-position:
    left center;
  background-repeat: no-repeat;
  background-size: contain;
`;

export const LogoTextGroup = styled.div`
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: start;
  gap: 3px;
`;

export const LogoDescription = styled.span`
  color: rgba(255, 255, 255, .48);
  font-size: var(--font-size-12);
    padding-left: 20px;
  font-weight: 500;
  letter-spacing: -.1px;
`;

export const LogoCompact =
    styled.div`
    display: inline-flex;
    width: 40px;
    height: 40px;
    align-items: center;
    justify-content: center;
    border: 1px solid
      rgba(245, 129, 31, 0.45);
    border-radius: 10px;
    background-color:
      rgba(245, 129, 31, 0.12);
    color: ${ACCENT};
    font-size: var(--font-size-14);
    font-weight: 800;
    letter-spacing: -0.3px;
  `;

export const MenuSection =
    styled.div`
    min-height: 0;
    flex: 1;
    padding: 16px 10px 14px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color:
      rgba(255, 255, 255, 0.18)
      transparent;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 999px;
      background-color:
        rgba(255, 255, 255, 0.18);
    }
  `;

export const MenuSectionLabel =
    styled.div`
    margin: ${({$group}) => $group === "support" ? "auto 9px 5px" : "8px 9px 9px"};
    padding-top: ${({$group}) => $group === "support" ? "12px" : "0"};
    color:
      rgba(255, 255, 255, 0.42);
    font-size: ${({$group}) => $group === "support" ? "9px" : "10px"};
    font-weight: 700;
    letter-spacing: ${({$group}) => $group === "support" ? ".7px" : "1px"};
    text-transform: uppercase;
  `;

export const Menu = styled.ul`
  display: flex;
  width: 100%;
  min-height: 100%;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const MenuItem = styled.li`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-bottom: ${({$support}) => $support ? "2px" : "4px"};
  border-radius: 8px;

  ${({$active}) =>
    $active &&
    css`
      background-color:
        rgba(255, 255, 255, 0.09);

      &::before {
        position: absolute;
        top: 8px;
        left: -10px;
        width: 3px;
        height: 32px;
        border-radius:
          0 2px 2px 0;
        background-color:
          ${ACCENT};
        content: "";
      }
    `}
`;

export const MenuLink = styled(Link)`
  display: grid;
  width: 100%;
  min-height: ${({$support}) => $support ? "40px" : "46px"};
  box-sizing: border-box;
  grid-template-columns:
    34px
    ${({$collapsed}) =>
    $collapsed
        ? "0"
        : "minmax(0, 1fr)"}
    ${({$collapsed}) =>
    $collapsed
        ? "0"
        : "18px"};
  align-items: center;
  gap:
    ${({$collapsed}) =>
    $collapsed
        ? "0"
        : "8px"};
  padding:
    ${({$collapsed}) =>
    $collapsed
        ? "0 11px"
        : "0 12px"};
  overflow: hidden;
  border-radius: 8px;
  color:
    ${({$active, $disabled}) =>
    $disabled
        ? "rgba(255, 255, 255, 0.28)"
        :
    $active
        ? ACCENT
        : TEXT_DEFAULT};
  text-decoration: none;
  transition:
    background-color 0.15s ease,
    color 0.15s ease;

  cursor: ${({$disabled}) => $disabled ? "not-allowed" : "pointer"};

  &:hover {
    background-color: ${({$disabled}) => $disabled ? "transparent" : "rgba(255, 255, 255, 0.07)"};
    color: ${({$disabled, $active}) =>
      $disabled
          ? "rgba(255, 255, 255, 0.28)"
          : $active
              ? ACCENT
              : TEXT_STRONG};
  }

  &:focus-visible {
    outline:
      1px solid ${ACCENT};
    outline-offset: -1px;
  }
`;

export const MenuIcon = styled.span`
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  justify-self: center;
  color: inherit;
  opacity:
    ${({$active, $disabled}) =>
    $disabled
        ? .35
        :
    $active
        ? 1
        : 0.62};
  transition:
    color 0.15s ease,
    opacity 0.15s ease;

  svg {
    display: block;
    width: 22px;
    height: 22px;
    pointer-events: none;
  }

  ${({$help}) => $help && css`
    position: relative;
    border: 1.5px solid currentColor;
    border-radius: 50%;
    background-image: none !important;

    &::after {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: rgba(255, 255, 255, .72);
      font-size: var(--font-size-15);
      font-weight: 800;
      content: "?";
    }
  `}
`;

export const MenuLabel =
    styled.span`
    min-width: 0;
    overflow: hidden;
    color: inherit;
    font-size: ${({$support}) => $support ? "12px" : "14px"};
    font-weight: 600;
    line-height: 1.2;
    opacity:
      ${({$collapsed}) =>
        $collapsed
            ? 0
            : 1};
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: opacity 0.12s ease;
  `;

export const DropIcon = styled.span`
  display: inline-block;
  width: 7px;
  height: 7px;
  justify-self: center;
  border-right:
    1.5px solid currentColor;
  border-bottom:
    1.5px solid currentColor;
  transform:
    rotate(
      ${({$open}) =>
    $open
        ? "225deg"
        : "45deg"}
    );
  transition:
    transform 0.18s ease;
`;

export const SubMenu = styled.div`
  display: flex;
  max-height:
    ${({$active, $collapsed, $itemCount, $maxVisible = 20}) => {
  if (!$active || $collapsed) {
    return "0";
  }

  const visibleCount =
      Math.min(
          $itemCount,
          $maxVisible
      );

  return `${visibleCount * 36 + 18}px`;
}};
  flex-direction: column;
  gap: 2px;
  padding:
    ${({$active, $collapsed}) =>
    $active && !$collapsed
        ? "5px 8px 9px 44px"
        : "0 8px 0 44px"};
  overflow-y:
    ${({$itemCount, $maxVisible = 20}) =>
    $itemCount > $maxVisible
        ? "auto"
        : "hidden"};
  overflow-x: hidden;
  opacity:
    ${({$active, $collapsed}) =>
    $active && !$collapsed
        ? 1
        : 0};
  transition:
    max-height 0.22s ease,
    padding 0.22s ease,
    opacity 0.15s ease;
`;

export const SubMenuItem =
    styled.div`
    position: relative;
    display: flex;
    min-height: 32px;
    align-items: center;
    border-radius: 6px;
    background-color:
      ${({$selected}) =>
        $selected
            ? "rgba(245, 129, 31, 0.1)"
            : "transparent"};

    ${({$selected}) =>
        $selected &&
        css`
        &::before {
          position: absolute;
          top: 50%;
          left: -13px;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color:
            ${ACCENT};
          content: "";
          transform:
            translateY(-50%);
        }
      `}
  `;

export const SubMenuLink =
    styled(Link)`
    display: block;
    min-width: 0;
    flex: 1;
    padding: 8px 9px;
    overflow: hidden;
    color:
      ${({$selected}) =>
        $selected
            ? TEXT_STRONG
            : "rgba(255, 255, 255, 0.54)"};
    font-size: var(--font-size-12);
    font-weight:
      ${({$selected}) =>
        $selected
            ? 700
            : 500};
    line-height: 1;
    text-decoration: none;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      color: ${TEXT_STRONG};
    }
  `;

export const CustomReportRow =
    styled(SubMenuItem)`
    padding-right: 4px;

    & > *:last-child:not(a) {
      flex: 0 0 auto;
    }
  `;

export const ReportDivider =
    styled.hr`
    width: calc(100% - 10px);
    height: 1px;
    margin: 5px 0;
    border: 0;
    background-color:
      rgba(255, 255, 255, 0.08);
  `;

export const AsideFooter =
    styled.div`
    flex: 0 0 auto;
    border-top:
      1px solid ${SIDEBAR_BORDER};
  `;

export const Narrow = styled.div`
  padding: 10px;
`;

export const CollapseButton =
    styled.button`
    display: flex;
    width: 100%;
    min-height: 40px;
    align-items: center;
    justify-content:
      ${({$collapsed}) =>
        $collapsed
            ? "center"
            : "flex-start"};
    gap: 9px;
    padding:
      ${({$collapsed}) =>
        $collapsed
            ? "0"
            : "0 11px"};
    border: 0;
    border-radius: 7px;
    background-color:
      transparent;
    color:
      rgba(255, 255, 255, 0.46);
    cursor: pointer;

    &:hover {
      background-color:
        rgba(255, 255, 255, 0.06);
      color: ${TEXT_STRONG};
    }

    &:focus-visible {
      outline:
        1px solid ${ACCENT};
      outline-offset: -1px;
    }
  `;

export const BtnNarrow =
    styled.span`
    position: relative;
    display: inline-block;
    width: 25px;
    height: 25px;
    flex: 0 0 25px;
    border: 1px solid
      rgba(255, 255, 255, 0.12);
    border-radius: 7px;

    &::before {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 7px;
      height: 7px;
      border-left:
        1.5px solid currentColor;
      border-bottom:
        1.5px solid currentColor;
      content: "";
      transform:
        translate(-35%, -50%)
        rotate(
          ${({$collapsed}) =>
        $collapsed
            ? "225deg"
            : "45deg"}
        );
      transition:
        transform 0.2s ease;
    }
  `;

export const CollapseText =
    styled.span`
    overflow: hidden;
    font-size: var(--font-size-12);
    font-weight: 600;
    opacity:
      ${({$collapsed}) =>
        $collapsed
            ? 0
            : 1};
    white-space: nowrap;
    transition: opacity 0.12s ease;
  `;
